var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 110,
    viewBox: "0 0 159 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.798 15.492C135.232 15.3499 117.399 14.9357 116.018 15.0422C116.018 15.0422 114.904 7.4613 114.371 5.18289C114.171 4.33662 113.614 1.63212 112.96 0.247314H106.723C105.99 2.04637 105.373 4.67395 105.155 5.69775C104.622 8.18921 103.968 12.604 103.592 15.0422C103.592 15.0422 87.3214 15.4032 84.2452 15.5334C83.6458 15.5571 71.4258 15.8885 61.18 17.1727V21.1199C70.0633 22.3035 88.3872 22.3746 92.7653 22.4101C94.2489 22.4219 103.913 22.4101 104.337 22.4101C104.337 22.4101 105.473 34.3923 108.403 43.5355H112.14C113.323 37.6326 114.371 30.7458 115.164 22.3035C115.164 22.3035 129.807 22.3035 135.226 22.3035C141.93 22.3035 152.23 22.0076 158.522 20.972V17.368C153.526 16.4152 143.316 15.6044 139.792 15.492H139.798Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.431415,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9622 37.313L55.5264 70.7952",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "5 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2852 56.1096H16.114V70.2808H30.2852V56.1096Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25177 109.116V86.0698H39.5165V109.116",
    stroke: "black",
    strokeWidth: 12.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRps);
export default __webpack_public_path__ + "static/media/RPS.2c385d20.svg";
export { ForwardRef as ReactComponent };